import { useRef, useState } from 'react';
import { command, errorText, newKey, uncertain } from '../models/attendance';
import { useAttendance } from './AttendanceProvider';

// Keep only PIN-free frozen requests in memory, scoped to the mounted actor UI.
export function useCommand(reload = async () => {}) {
  const attendance = useAttendance();
  const pending = useRef(null), busy = useRef(false);
  const [saving, setSaving] = useState(false), [error, setError] = useState(null);
  async function run(method, path, body, { sameDecision = false, fresh = false } = {}) {
    if (busy.current) return null;
    const { pin, current_pin, ...safe } = body;
    if (fresh) pending.current = null;
    const allowReason = sameDecision && pending.current?.reasonRequired && pending.current.path === path;
    if (pending.current && (pending.current.path !== path || JSON.stringify(pending.current.body) !== JSON.stringify(safe)) && !allowReason) {
      const failure = new Error('Retry the previous request before making another change.'); setError(failure); return null;
    }
    if (!pending.current) pending.current = { path, method, body: safe, key: newKey() };
    if (allowReason) { pending.current.body = safe; pending.current.reasonRequired = false; }
    const request = pending.current;
    busy.current = true; setSaving(true); setError(null);
    try {
      const payload = { ...request.body, ...(pin !== undefined ? { pin } : {}), ...(current_pin !== undefined ? { current_pin } : {}) };
      const result = attendance?.execute ? await attendance.execute(method, path, payload, request.key) : await command(method, path, payload, request.key)();
      pending.current = null; if (!attendance?.execute || reload !== attendance.reload) await reload(); return result;
    } catch (failure) {
      if (failure.code === 'ATTENDANCE_REASON_REQUIRED') pending.current.reasonRequired = true;
      if (!uncertain(failure) && failure.code !== 'ATTENDANCE_REASON_REQUIRED') pending.current = null;
      if (failure.code === 'ATTENDANCE_VERSION_CONFLICT') await reload();
      failure.message = errorText(failure); setError(failure); throw failure;
    } finally { busy.current = false; setSaving(false); }
  }
  return { run, saving, error };
}
